import {
  ExampleImageCellWithoutStyle,
} from '@bingads-webui-campaign-react/ads-studio-app-shared-components';
import {
  withOverridableStyles,
} from '@bingads-webui-campaign-react/ads-studio-shared-components';
import { useExampleImageCellStyles } from './style';

export const ExampleImageCell = withOverridableStyles(ExampleImageCellWithoutStyle, useExampleImageCellStyles);
